import React, { useState } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import Card from "./card";
import MinimizableContainer from "./MinimizableContainer";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import getFormDashboard from "../../../api/getFormDashboard";
import Loader from '../../utilities/loader';

const Dashboard = ({ togglePreference, minimized, setMinimized }) => {
  const selectedProject = useSelector(state => state.selectedProject);
  const { form_name } = useParams();
  const { isLoading, data } = useQuery("getFormDashboard" + form_name, () => getFormDashboard(selectedProject.name, form_name));

  // Console log pour voir les données de getFormDashboard
  // console.log("=== DASHBOARD DATA ===");
  // console.log("Project name:", selectedProject.name);
  // console.log("Form name:", form_name);
  // console.log("Is loading:", isLoading);
  // console.log("Dashboard data:", data);
  // console.log("Dashboard data.data:", data?.data);
  // console.log("Dashboard data.data.data:", data?.data?.data);
  // console.log("=========================");

  const dashboardStyle = {
    height: "100%",
    position: "relative",
    width: "100%",
    top: "0px",
    left: "0px",
  };

  if (isLoading) return <><Loader /></>

  const { number_of_documents, form_created_by, Number_of_columns, form_creation_date } = data?.data?.data;

  return (
    <MinimizableContainer
      style={dashboardStyle}
      className="form-header"
      Title={Title}
      minimized={minimized}
      onMinimizeClick={() => setMinimized(!minimized)}
      OptionsButton={() => (
        <PreferenceButton togglePreference={togglePreference} />
      )}
    >
      <Container fluid>
        <Row>
          <Col lg="3" md="12">
            <Card formsCount={number_of_documents} type="Validated" bg="rgb(106, 117, 148)" />
          </Col>
          <Col lg="3" md="12">
            <Card formsCount={Number_of_columns} type="Columns" bg="#A63247" />
          </Col>
          <Col lg="3" md="12">
            <Card formsCount={form_created_by} type="Creator" bg="#3F6274" />
          </Col>
          <Col lg="3" md="12">
            <Card
              formsCount={form_creation_date}
              type="Creation Date"
              bg="#590202"
            />
          </Col>
        </Row>
      </Container>
    </MinimizableContainer>
  );
};

function PreferenceButton({ togglePreference }) {
  return (
    <Button onClick={() => togglePreference()}>
      <i className="ti-settings" />
    </Button>
  );
}

function Title() {
  return <h3 className="heading">Form dashboard</h3>;
}



export default Dashboard;
